<template>
    <div>
    <q-markup-table style="box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;" wrap-cells dense bordered >
      <thead>
        <tr>
          <th class="text-left"  style="width: 70%">Conference submission criteria </th>
          <th>3</th>
          <th>2</th>
          <th>1</th>
          <th>0</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="text-left"><b>Alignment:</b> does the proposal align with the overall conference themes and one or more of the conference sub-themes?</td>
          <td><q-checkbox size="md" v-model="alignmentOne" val="3" /></td>
          <td><q-checkbox size="md" v-model="alignmentTwo" val="3" /></td>
          <td><q-checkbox size="md" v-model="alignmentThree" val="3" /></td>
          <td><q-checkbox size="md" v-model="alignmentFour" val="3" /></td>
        </tr>

        <tr>
          <td class="text-left"><b>Engaging learning experience:</b> does the proposal seem likely to be of interest to the intended audience and to provide an engaging learning experience? </td>
          <td><q-checkbox size="md" v-model="engagingOne" val="3" /></td>
          <td><q-checkbox size="md" v-model="engagingTwo" val="3" /></td>
          <td><q-checkbox size="md" v-model="engagingThree" val="3" /></td>
          <td><q-checkbox size="md" v-model="engagingFour" val="3" /></td>
        </tr>

        <tr>
          <td class="text-left"><b>Transferability:</b> does the proposal demonstrate how delegates will learn from, adapt and be able to use approaches in their own practice? </td>
          <td><q-checkbox size="md" v-model="transferabilityOne" val="3" /></td>
          <td><q-checkbox size="md" v-model="transferabilityTwo" val="3" /></td>
          <td><q-checkbox size="md" v-model="transferabilityThree" val="3" /></td>
          <td><q-checkbox size="md" v-model="transferabilityFour" val="3" /></td>
        </tr>
        
      </tbody>
    </q-markup-table>

    <ul style="margin-top: 3rem;">
        <li>3 – criteria met.</li>
        <li>2 – some evidence of meeting criteria.</li>
        <li>1 – limited evidence of meeting criteria.</li>
        <li>0 – no evidence of meeting criteria.</li>
    </ul>

  </div>    
</template>

<script setup>
import { ref } from "@vue/reactivity"


const alignmentOne = ref(false)
const alignmentTwo = ref(false)
const alignmentThree = ref(false)
const alignmentFour = ref(false)

const engagingOne = ref(false)
const engagingTwo = ref(false)
const engagingThree = ref(false)
const engagingFour = ref(false)

const transferabilityOne = ref(false)
const transferabilityTwo = ref(false)
const transferabilityThree = ref(false)
const transferabilityFour = ref(false)

</script>

<style>

.q-markup-table {
    text-align: center;
    font-size: 2rem;
}

.q-table tbody td, th {
    font-size: 1.8rem !important;
}


</style>